<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-left></vdr-ab-left>
    <vdr-ab-right>
      <vdr-action-bar-items
        [locationId]="'email-templates'"
      ></vdr-action-bar-items>
    </vdr-ab-right>
  </vdr-action-bar>
  <vdr-page-detail-layout>
    <table class="table">
      <thead>
        <tr>
          <th style="text-align: left">{{ "email.code" | translate }}</th>
          <th>{{ "email.translations" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of emailEvents; let i = index">
          <td style="text-align: left">
            <a
              class="button-ghost"
              [routerLink]="['/extensions/email-templates', item.value]"
              [queryParams]="{ lang: 'en' }"
            >
              <span>
                {{ translateName(item.value) }}
              </span>
              <clr-icon shape="arrow right" />
            </a>
          </td>
          <td>
            <a
              class="button-ghost mr-1"
              *ngFor="let langCode of availableLanguageCodes$ | async"
              [routerLink]="['/extensions/email-templates', item.value]"
              [queryParams]="{ lang: langCode }"
              >{{ langCode | localeLanguageName }}</a
            >
          </td>
        </tr>
      </tbody>
    </table>
  </vdr-page-detail-layout>
</vdr-page-block>
